export const iconFontAwesomeMedicalHealthAccessibleIcon = (
	<i className="fa-solid fa-accessible-icon"></i>
);
